import React from "react";
import { Link } from "@reach/router";

export const NavLink = props => (
  <Link
    {...props}
    getProps={({ href, location }) => {
      const isCurrent = `${location.pathname}${location.search}` === href;
      return {
        className: isCurrent ? "active" : ""
      };
    }}
  />
);



// WEBPACK FOOTER //
// ./src/components/NavLink.js